import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-12 w-full rounded-xl border-1.5 border-secondary-light bg-white px-3 py-3 app-text-body1 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-light focus-visible:outline-none focus-visible:border-contrast-light disabled:cursor-not-allowed disabled:bg-secondary-light",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
